import React, { useRef } from 'react';
import { ClientOnly } from 'remix-utils/client-only';
import { useCleengLowCode } from '~/hooks/use-cleeng-low-code';
import type { AuthData } from '~/utils/storefront';

interface CleengConfig {
  general: {
    cleeng_publisher_id: string;
    cleeng_environment: string;
  };
  styles: {
    [key: string]: string | number;
  };
}

interface CleengLowCodeProviderProps {
  config: CleengConfig;
  authData: AuthData;
}

export function CleengPaymentInfoLowCodeProvider({
  config,
  authData,
}: CleengLowCodeProviderProps) {
  const { cleeng_publisher_id, cleeng_environment } = config?.general;

  const containerRef = useRef<HTMLDivElement>(null);

  const { isCleengLowCodeLoading } = useCleengLowCode({
    cleeng_environment,
    authData,
  });

  if (isCleengLowCodeLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-32 w-32 animate-spin rounded-full border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return (
    <ClientOnly fallback={<></>}>
      {() => (
        <div className="payment-info mx-auto h-screen w-[100%] max-w-[1000px] flex-col lg:flex-row">
          <div
            ref={containerRef}
            data-cleeng-widget="account"
            data-cleeng-publisher-id={cleeng_publisher_id}
            className="h-full w-full"
          />
        </div>
      )}
    </ClientOnly>
  );
}
